export default "__VITE_ASSET__BeenUbly__"